import MAdmin from './admin.menu'
import MSupplyChainManager from './scm.menu'
import MLogisticsOfficer from './lo.menu'
import MWarehouseOfficer from './wo.menu'
import MRetailManager from './rm.menu'
import MPurchaseOfficer from './po.menu'
import MRetailOfficer from './ro.menu'
import MProduction from './prd.menu'

export const getSidebarMenus = user => {
  const allowIn = Number(user?.allow_in) === 1
  const allowOut = Number(user?.allow_out) === 1

  switch (user.role) {
    case 'admin': {
      return MAdmin
    }
    case 'scm': {
      return MSupplyChainManager
    }
    case 'lo': {
      return MLogisticsOfficer
    }
    case 'wo': {
      const stockIn = [
        'wo.purchase-orders.requests',
        'wo.purchase-orders.receiving'
      ]

      const stockOut = [
        'wo.purchase-orders.approvals',
        'wo.purchase-orders.posting'
      ]

      return MWarehouseOfficer.filter(
        menu => {
          if (stockIn.includes(menu.link.name)) {
            return allowIn
          }

          if (stockOut.includes(menu.link.name)) {
            return allowOut
          }

          if (menu.link.name === 'wo.purchase-orders') {
            return allowIn || allowOut
          }

          return menu
        }
      )
    }
    case 'rm': {
      return MRetailManager
    }
    case 'po': {
      return MPurchaseOfficer
    }
    case 'ro': {
      return MRetailOfficer
    }
    case 'prd': {
      return MProduction
    }
    default: {
      return []
    }
  }
}
